import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { Quota } from "src/app/backend/models/quota";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class QuotaBackend {
  private readonly http = inject(HttpClient);

  listAllCredits(): Observable<Quota[]> {
    return this.http
      .get<PaginatedResult<Quota>>(
        `${environment.snoots.api.notification}/quotas`
      )
      .pipe(
        map((response) => {
          return response.docs;
        })
      );
  }
}
